export default function scrollToVariant(variantId: number) {
    const anchor = `variant-${variantId}`;

    const anchorEl = document.getElementById(anchor);

    if (anchorEl) {
        anchorEl.scrollIntoView();
    }
}
